import Nav from '../components/shared/Nav';
import Footer from '../components/shared/Footer';
import PRHero from '../components/pixrow/PRHero';
import PRStatsBand from '../components/pixrow/PRStatsBand';
import PRDemo from '../components/pixrow/PRDemo';
import PRPipeline from '../components/pixrow/PRPipeline';
import PRPixViewerLink from '../components/pixrow/PRPixViewerLink';

export default function PixRowPage() {
  return (
    <div data-screen-label="03 PixRow">
      <Nav current="pixrow" />
      <PRHero />
      <PRStatsBand />
      <PRDemo />
      <PRPipeline />
      <PRPixViewerLink />
      <Footer />
    </div>
  );
}
